function format(price, currency = '$') {
    if(isNaN(price)) {
        return price;
    }

    const decimalPrice = (Math.round(price * 100) / 100).toFixed(2);
    return currency + decimalPrice;
}

export default format;
